import { ViewContext } from '../enums/viewContext';

export const DefaultLbmFilterSchema = {
	year_of_sale: {
		min: 2006,
		max: new Date().getFullYear(),
	},
	id: '',
	label: ViewContext.City,
	land_type_level_1: [],
	gfa: {
		min_gfa: 0,
		max_gfa: 0,
	},
	floor_area: {
		floor_area_ratio_min: 0,
		floor_area_ratio_max: 0,
	},
	offset: 0,
	limit: 1000,
	gross_land_area: {
		min: 0,
		max: 0,
	},
	development_status: [],
	isSold: '',
	isAldarPlot: '',
	development_categories: [],
	previous_gfa: {
		min_gfa: 0,
		max_gfa: 0,
	},
	previous_gross_land_area: {
		min: 0,
		max: 0,
	},
	previous_floor_area_ratio: {
		floor_area_ratio_min: 0,
		floor_area_ratio_max: 0,
	},
	previous_year_of_sale: {
		min: 2006,
		max: new Date().getFullYear(),
	},
	range: {
		min_gla: 0,
		max_gla: 0,
	},
};

export const lbmFilterForm = {
	...DefaultLbmFilterSchema,
};
